import styled from "styled-components";

/* Slogan text for login, forgot password and authentication style */
export const SloganText = styled.h2`
  color: var(--white);
  font-weight: var(--boldFont);
  line-height: 0.5em;
  text-transform: uppercase;
  z-index: 99;
  line-height: normal;
  margin-left: 40px;
  @media (max-width: 768px) {
    margin: 30px 15px 0;
  }
`;

/* Error page headline style */
export const HeadlineText = styled.h2`
  color: var(--orange);
  font-size: 4vw;
  font-weight: 600;
  font-family: var(--scriptFont);
  line-height: 1.5em;
  margin: 0;
  padding: 0;
  @media (max-width: 768px) {
    font-size: 48px;
  }
`;

/* Error page subtitle style*/
export const SubTitle = styled.h4`
  color: var(--orange);
  font-size: 2vw;
  font-weight: 500;
  font-family: var(--fontFamily);
  line-height: 0.5em;
  margin: 0;
  padding: 0;
  @media (max-width: 768px) {
    @media (max-width: 768px) {
      font-size: 26px;
    }
  }
`;

export const ForgotText = {
  fontSize: " 18px",
  color: " var(--white)",
  zIndex: "99",
  marginLeft: "40px",
};

export const FooterText = {
  fontSize: " 16px",
  color: " var(--black)",
  zIndex: "99",
  fontFamily: "var(--fontFamily",
  margin: "0",
  padding: "0",
};
